import dayjs, { Dayjs } from 'dayjs'

/** How many birthdays the "upcoming" strip shows by default. */
export const UPCOMING_BIRTHDAYS_LIMIT = 8

interface DatedBirthday {
  /** ISO date string (YYYY-MM-DD). */
  birthDate: string
}

/**
 * Returns the next `limit` birthdays ordered by their next occurrence from
 * `now`, ignoring the birth year. A birthday whose day/month has already passed
 * this year rolls over to next year, so it lands at the end of the list.
 *
 * Pure and order-stable: the input array is copied (never mutated) and ties on
 * `daysAway` keep the caller's original order.
 */
export function computeUpcomingBirthdays<T extends DatedBirthday>(
  birthdays: T[],
  now: Dayjs = dayjs().startOf('day'),
  limit: number = UPCOMING_BIRTHDAYS_LIMIT,
): T[] {
  const reference = now.startOf('day')
  return [...birthdays]
    .map((b) => {
      const bd = dayjs(b.birthDate, 'YYYY-MM-DD')
      let next = bd.year(reference.year())
      if (next.isBefore(reference, 'day')) next = next.add(1, 'year')
      return { b, daysAway: next.diff(reference, 'day') }
    })
    .sort((a, z) => a.daysAway - z.daysAway)
    .slice(0, limit)
    .map((x) => x.b)
}
